import React from "react";
import { Helmet } from "react-helmet-async";

export default function NotFound() {
  return (
    <div style={{ minHeight: "60vh", display: "flex", flexDirection: "column", alignItems: "center", justifyContent: "center" }}>
      <Helmet>
        <title>404 – Nie znaleziono strony | DJ Kusy</title>
        <meta name="robots" content="noindex" />
      </Helmet>
      <h1 style={{ fontSize: "3rem", color: "#e53e3e" }}>404</h1>
      <h2 style={{ fontSize: "1.5rem", marginBottom: 16 }}>Nie znaleziono strony</h2>
      <a href="/" style={{ color: "#3182ce", textDecoration: "underline" }}>Powrót na stronę główną</a>
    </div>
  );
}
